import gql from 'graphql-tag';

export const MUTATION_COUNT_EQUIPMENT_BY_BARCODE = gql`
  mutation countEquipmentByBarcode($dto: DtoCountEquipmentByBarcode!) {
    countEquipmentByBarcode(dto: $dto) {
      id
      journalId
      equipmentId
      status
      expectedQty
      actualQty
      variance
      notes
      countedBy
      countedByName
      countedAt
      equipment {
        id
        equipmentNum
        serial
        make
        model
        barcode
      }
    }
  }
`;
